import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { TextField, Grid, Card, CardContent, Button, Typography, CircularProgress } from '@material-ui/core';
import "./LogIn.css";
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import { makeStyles } from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import LoginApis from "../services/LoginService";
import HeaderApi from "../../../common-components/header/services/header-apis";
import { StateContext } from "../../../services/StateProvider";
import CommonUtils from "../../../services/utils";
import ResetPasswordDialogBox from "./ResetPasswordDialogBox";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
    width: '100%',
  },
  proceed: {
    "&:hover": {
        opacity: 1
    },
    background:
        "transparent linear-gradient(90deg, #0055A4 0%, #0079E6 100%) 0% 0% no-repeat padding-box",
    borderRadius: 18,
    font: 'Barlow',
    opacity: .8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none"
  },
  disabledButton: {
    background: "transparent linear-gradient(90deg, #bebfc046 0%, #bebfc046 100%) 0% 0% no-repeat padding-box",
    borderRadius: 18,
    font: "Barlow",
    opacity: 0.8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none"
  }
}));

const LogIn = () => {
  const history = useHistory();
  const classes = useStyles();
  const commonUtils = new CommonUtils();
  const LoginApi = new LoginApis();
  const headerApi = new HeaderApi();

  const [globalAccountState, globalAccountDispatch] = useContext(StateContext);
  const [loginInfo, setLoginInfo] = useState({
    userName: "",
    password: ""
  });
  const [isIdentified, setIsIdentified] = useState(true);
  const [loading, setLoading] = useState(false); // State to track loading
  const notIdentified = `The information you entered doesn't match our records. Please check and try again.`;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isForceResetPw, setIsForceResetPw] = useState(false);


  useEffect(() => {
    LoginApi.checkLoginStatus().then((response) => {
      let identifier = "is authenticated";
      if (!(response?.status === 401) && response.includes(identifier)) {
        goToHomePage();
      }
    });
  }, []);

  const isLoginProceed = () => {
    setLoading(true); // Start loading
    LoginApi.loginUser(loginInfo).then((response) => {
      sessionStorage.setItem("isAuthenticated", true);
      let logMessage = response?.message ? response?.message : response?.data?.message;
      let accessGranted = "Access granted.";
      let needResetPassword = "User is not allowed to sign in. Please reset your password"

      if (logMessage.includes(accessGranted)) {
        setIsIdentified(true);
        if (sessionStorage.getItem("isAuthenticated") === "true") {
          headerApi.getUserPreference().then((response) => {
            const model = response.model;
            headerApi.getUserProfile().then((data) => {
  
              if (data.status === 204) {
                let date = new Date();
                date = date.toISOString();
                const userDetailsCurrent = {
                  userId: "",
                  firstName: "",
                  middleName: "",
                  lastName: "",
                  userRole: "",
                  updatedDate: date,
                  phoneNumber: ""
                };
                globalAccountStateUpdate(model, userDetailsCurrent);
                sessionStorage.setItem("hasLoggedIn", true);
                 //temporary commented
                // headerApi.createUser(userDetailsCurrent).then((_data) => {
                // });
              } else {
                globalAccountStateUpdate(model, data.model);
                sessionStorage.setItem("hasLoggedIn", true);

                if (data?.model?.userRole.includes("EMTSUADMIN") || data?.model?.userRole.includes("EMTCADMIN")) {
                  goToUserManagementPage();
                } else {
                  goToHomePage();
                }



              }
            });
          });
        }

        const globalAccountStateUpdate = (model, userProfile) => {
          const initialAccountState = {
            account: {
              accountName: model.lastAccessedAccountName,
              accountId: model.lastAccessedAccountId
            },
            location: [
              {
                value: model.lastAccessedLocationId,
                label: model.lastAccessedLocationName
              }
            ],
            userSetting: model,
            userProfile
          };
          localStorage.setItem("accountInfo", JSON.stringify(initialAccountState));
          localStorage.setItem("accountInfoUserMeasurementSystemValue", JSON.stringify(initialAccountState.userSetting.userMeasurementSystemValue));
          globalAccountDispatch({
            accountInfo: initialAccountState,
            type: "UPDATE"
          });
        };

      } else if (logMessage.includes(needResetPassword)) {
        setIsForceResetPw(true);
        setDialogOpen(true);
        setLoading(false); // Stop loading
        sessionStorage.setItem("isAuthenticated", false);
      } else {
        setIsIdentified(false);
        setLoading(false); // Stop loading
        sessionStorage.setItem("isAuthenticated", false);
      }
    }).catch(() => {
      setLoading(false); // Stop loading in case of error
      sessionStorage.setItem("isAuthenticated", false);
    });
  };

  const goToHomePage = () => {
    history.push({ pathname: "/home" });
  };

  const goToUserManagementPage = () => {
    history.push({ pathname: "/userManagementPage" });
  }


  const handleDialogOpen = () => {
    setDialogOpen(true);
  };


const closeDialog = () => {
  setDialogOpen(false);
}
  
  return (
    <div style={{ height: window.innerHeight }} className="background-image-login-grad">
      <div className="background-image-login">
        <Grid container>
          <Card style={{ width: '40%', height: 350, marginLeft: '30%', marginTop: '14%', backgroundColor: 'whitesmoke' }}>
            <CardContent style={{ padding: 0 }}>
              <Grid container>
                <Grid item sm={6} style={{ padding: 10 }}>
                  <Grid container spacing={1} alignItems="flex-end" style={{ marginTop: 20, marginLeft: 5 }}>
                    <Grid item sm={9}>
                      <Typography variant="body2" style={{ fontSize: 23, paddingBottom: 5, color: '#0055a4' }}>Welcome!</Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} alignItems="flex-end" style={{ marginLeft: 5 }}>
                    <Grid item>
                      <AssignmentInd style={{ fontSize: 45, verticalAlign: 'bottom', color: '#0055a4' }}></AssignmentInd>
                    </Grid>
                    <Grid item sm={9}>
                      <TextField
                        id="outlined-basic"
                        label="Username"
                        variant="outlined"
                        style={{ fontSize: 31, backgroundColor: 'white' }}
                        value={loginInfo.userName}
                        onChange={(e) => setLoginInfo({ ...loginInfo, userName: commonUtils.removeLeadingSpaces(e.target.value) })}
                        fullWidth
                        disabled={loading}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} alignItems="flex-end" style={{ marginTop: 10, marginLeft: 5 }}>
                    <Grid item>
                      <LockIcon style={{ fontSize: 45, verticalAlign: 'bottom', color: '#0055a4' }}></LockIcon>
                    </Grid>
                    <Grid item sm={9}>
                      <TextField
                        id="outlined-basic"
                        label="Password"
                        variant="outlined"
                        type="password"
                        style={{ fontSize: 31, backgroundColor: 'white' }}
                        value={loginInfo.password}
                        onChange={(e) => setLoginInfo({ ...loginInfo, password: commonUtils.removeLeadingSpaces(e.target.value) })}
                        fullWidth
                        disabled={loading}
                      />
                    </Grid>
                  </Grid>
                  {/* temporary hidden */}
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item sm={3}></Grid>
                    <Grid item sm={6}>
                      <Button
                        size="small"
                        style={{ width: '100%', marginTop: '3%', color: '#0055a4' }}
                        onClick={handleDialogOpen}
                        disabled={loading} // Disable button when loading
                      >
                        Password Reset
                      </Button>
                    </Grid>
                    <Grid item sm={3}></Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item sm={3}></Grid>
                    <Grid item sm={6}>
                      <Button
                        className={classes.proceed}
                        variant="contained"
                        style={{ width: '100%', marginTop: '10%' }}
                        onClick={isLoginProceed}
                        disabled={loading} // Disable button when loading
                      >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'LOGIN'}
                      </Button>
                    </Grid>
                    <Grid item sm={3}></Grid>
                  </Grid>

                  <Grid container spacing={1} alignItems="flex-end" style={{ marginTop: 20, marginLeft: 5 }}>
                    {!isIdentified ? (
                      <>
                        <Grid item>
                          <AssignmentLateIcon style={{ fontSize: 33, verticalAlign: 'bottom', color: 'orange' }}></AssignmentLateIcon>
                        </Grid>
                        <Grid item sm={9}>
                          <Typography variant="body2" style={{ fontSize: 10, paddingBottom: 5, color: 'orange' }}>{notIdentified}</Typography>
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid item sm={6} style={{ backgroundColor: '#0055a4', height: 350, paddingTop: 20 }}>
                  <img src={require("../../../assets/logo.svg")} className="emtrack-logo" alt="emtrack-logo" style={{ backgroundColor: '#0055a4', width: '70%', padding: '5%', margin: '12%' }} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <ResetPasswordDialogBox dialogOpen={dialogOpen} closeDialog={closeDialog} isForceResetPw={isForceResetPw}/>
        
      </div>
    </div>
  );
};

export default LogIn;